export default class Jikan {
  private hour: number
  private minute: number
  private tmpDateValue: Date

  constructor(hour: number, minute: number) {
    this.hour = hour
    this.minute = minute
    this.tmpDateValue = this.createTmpDateValue(this.hour, this.minute)
  }

  public static generateByDate(date: Date): Jikan {
    const hour = date.getHours()
    const minute = date.getMinutes()
    return new Jikan(hour, minute)
  }
  public static generateByJikanStr(jikanStr: string): Jikan | null {
    const jikanParts: string[] = jikanStr.split(':')
    if (jikanParts.length < 2) {
      return null
    }
    const hms = jikanParts.map(p => Number(p))
    if (hms.some(p => Number.isNaN(p))) {
      return null
    }
    return new Jikan(hms[0], hms[1])
  }

  private createTmpDateValue(hour: number, minute: number): Date {
    const date = new Date()
    date.setHours(hour)
    date.setMinutes(minute)
    return date
  }

  get hourValue(): number {
    return this.hour
  }
  set hourValue(hour: number) {
    this.hour = hour
  }

  get minuteValue(): number {
    return this.minute
  }
  set minuteValue(minute: number) {
    this.minute = minute
  }

  get dateValue(): Date {
    return this.tmpDateValue ? this.tmpDateValue : new Date()
  }

  public changeValueByDate(date: Date): void {
    this.hour = date.getHours()
    this.minute = date.getMinutes()
    this.tmpDateValue.setHours(this.hour)
    this.tmpDateValue.setMinutes(this.minute)
  }

  public getDateValue(baseDate: Date): Date {
    const date = new Date(baseDate)
    date.setHours(this.hour)
    date.setMinutes(this.minute)
    return date
  }

  public after(compareJikan: Jikan): boolean {
    if (this.hour > compareJikan.hour) {
      return true
    } else if (this.hour < compareJikan.hour) {
      return false
    }

    if (this.minute > compareJikan.minute) {
      return true
    } else {
      return false
    }
  }

  public afterEquals(compareJikan: Jikan): boolean {
    const isAfter = this.after(compareJikan)
    if (isAfter) {
      return true
    }

    if (this.hour === compareJikan.hour && this.minute === compareJikan.minute) {
      return true
    }
    return false
  }

  public before(compareJikan: Jikan): boolean {
    return !this.afterEquals(compareJikan)
  }

  public beforeEquals(compareJikan: Jikan): boolean {
    return !this.after(compareJikan)
  }

  public toString(): string {
    return `${String(this.hour).padStart(2, '0')}:${String(this.minute).padStart(2, '0')}`
  }
}
